import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_ADD_WORKFLOW_PRODUCT,
  REQUEST_CREATE_WORKFLOW,
  REQUEST_DELETE_WORKFLOW,
  REQUEST_DELETE_WORKFLOW_PRODUCT,
  REQUEST_FETCH_WORKFLOW_PRODUCT,
  REQUEST_UPDATE_WORKFLOW,
  REQUEST_UPDATE_WORKFLOW_PRODUCT,
  REQUEST_WORKFLOW,
  REQUEST_WORKFLOWS_FILTER,
  REQUEST_ADD_WORKFLOW_TASK,
  REQUEST_UPDATE_WORKFLOW_TASK,
  REQUEST_DELETE_WORKFLOW_TASK,
  REQUEST_COMPANY_WORKFLOW,
  REQUEST_UPDATE_COMPANY_WORKFLOW_TASK,
  REQUEST_CREATE_COMPANY_WORKFLOW_TASK,
} from './constants';
import { GET_MY } from '../../containers/App/constants';

export function fetchWorkflow(workflowId) {
  return {
    type: GET_MY,
    id: REQUEST_WORKFLOW,
    workflowId,
    work: REQUEST_WORKFLOW,
    gate: REQUEST_WORKFLOW + workflowId,
    path: `workflows/${workflowId}`,
  };
}

export function fetchWorkflows(offset = 0, limit = FILTER_DEFAULT_LIMIT) {
  return {
    type: REQUEST_WORKFLOWS_FILTER,
  };
}

export function changeWorkflowFilter(name, value) {
  return {
    type: REQUEST_WORKFLOWS_FILTER,
    name,
    value,
  };
}

export function createWorkflow(dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_WORKFLOW,
    work: REQUEST_CREATE_WORKFLOW,
    gate: REQUEST_CREATE_WORKFLOW,
    callback,
    path: 'workflows',
    post: dto,
  };
}

export function updateWorkflow(id, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_WORKFLOW,
    work: REQUEST_UPDATE_WORKFLOW,
    gate: REQUEST_UPDATE_WORKFLOW,
    path: `workflows/${id}`,
    patch: dto,
    putOnComplete: [fetchWorkflow(id)],
    callback,
  };
}

export function deleteWorkflow(id) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_WORKFLOW,
    work: REQUEST_DELETE_WORKFLOW,
    gate: REQUEST_DELETE_WORKFLOW,
    path: `workflows/${id}`,
    delete: {},
    putOnComplete: [fetchWorkflows()],
  };
}

export function addWorkflowTask(workflowId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_WORKFLOW_TASK,
    work: REQUEST_ADD_WORKFLOW_TASK,
    gate: REQUEST_ADD_WORKFLOW_TASK,
    path: `workflows/${workflowId}/tasks`,
    post: dto,
    putOnComplete: [fetchWorkflow(workflowId)],
    callback,
  };
}

export function updateWorkflowTask(workflowId, taskId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_WORKFLOW_TASK,
    work: REQUEST_UPDATE_WORKFLOW_TASK,
    gate: REQUEST_UPDATE_WORKFLOW_TASK,
    path: `workflows/${workflowId}/tasks/${taskId}`,
    patch: dto,
    putOnComplete: [fetchWorkflow(workflowId)],
    callback,
  };
}

export function deleteWorkflowTask(workflowId, taskId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_WORKFLOW_TASK,
    work: REQUEST_DELETE_WORKFLOW_TASK,
    gate: REQUEST_DELETE_WORKFLOW_TASK,
    path: `workflows/${workflowId}/tasks/${taskId}`,
    delete: {},
    putOnComplete: [fetchWorkflow(workflowId)],
    callback,
  };
}

export function addWorkflowProduct(workflowId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_WORKFLOW_PRODUCT,
    work: REQUEST_ADD_WORKFLOW_PRODUCT,
    gate: REQUEST_ADD_WORKFLOW_PRODUCT,
    post: dto,
    path: `workflows/${workflowId}/workflow-product`,
    putOnComplete: [fetchWorkflow(workflowId)],
    callback,
  };
}

export function fetchWorkflowProduct(workflowId, workflowProductId) {
  return {
    type: GET_MY,
    id: REQUEST_FETCH_WORKFLOW_PRODUCT,
    work: REQUEST_FETCH_WORKFLOW_PRODUCT,
    gate: REQUEST_FETCH_WORKFLOW_PRODUCT + workflowProductId,
    path: `workflows/${workflowId}/workflow-product/${workflowProductId}`,
  };
}

export function updateWorkflowProduct(workflowId, workflowProductId, dto) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_WORKFLOW_PRODUCT,
    work: REQUEST_UPDATE_WORKFLOW_PRODUCT,
    gate: REQUEST_UPDATE_WORKFLOW_PRODUCT + workflowProductId,
    path: `workflows/${workflowId}/workflow-product/${workflowProductId}`,
    patch: dto,
    putOnComplete: [fetchWorkflowProduct(workflowId, workflowProductId), fetchWorkflow(workflowId)],
  };
}

export function deleteWorkflowProduct(workflowId, workflowProductId) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_WORKFLOW_PRODUCT,
    work: REQUEST_DELETE_WORKFLOW_PRODUCT,
    gate: REQUEST_DELETE_WORKFLOW_PRODUCT + workflowProductId,
    path: `workflows/${workflowId}/workflow-product/${workflowProductId}`,
    delete: {},
    putOnComplete: [fetchWorkflow(workflowId)],
  };
}

export function fetchCompanyWorkflow(companyId, workflowId) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_WORKFLOW,
    work: REQUEST_COMPANY_WORKFLOW,
    gate: REQUEST_COMPANY_WORKFLOW + companyId + workflowId,
    path: `company-workflows/${companyId}/workflows/${workflowId}`,
  };
}

export function createCompanyWorkflowTask(companyId, workflowId, taskId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_COMPANY_WORKFLOW_TASK,
    work: REQUEST_CREATE_COMPANY_WORKFLOW_TASK,
    gate: REQUEST_CREATE_COMPANY_WORKFLOW_TASK,
    path: `company-workflows/${companyId}/workflows/${workflowId}/tasks/${taskId}/company-tasks`,
    post: dto,
    putOnComplete: [fetchCompanyWorkflow(companyId, workflowId)],
    callback,
  };
}

export function updateCompanyWorkflowTask(companyId, workflowId, taskId, companyTaskId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_COMPANY_WORKFLOW_TASK,
    work: REQUEST_UPDATE_COMPANY_WORKFLOW_TASK,
    gate: REQUEST_UPDATE_COMPANY_WORKFLOW_TASK,
    path: `company-workflows/${companyId}/workflows/${workflowId}/tasks/${taskId}/company-tasks/${companyTaskId}`,
    patch: dto,
    putOnComplete: [fetchCompanyWorkflow(companyId, workflowId)],
    callback,
  };
}
